/**
 * Sentry is fail-closed so non-production builds cannot consume the production
 * organization's quota. Production must opt in explicitly at build time.
 */
export const isSentryEnabled = (environment, enabled) =>
  environment === 'production' && enabled === 'true';
